import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addUserInfo, addUserName, clearUserData } from "../../redux/slices/userSlice";
import { fetchCredeauData } from "../../lib/credlibkit";
import { storeAccessToken, storeAttributeKey, storeCustomerID, storeLeadID, storePhoneNo, storeProductId, storeToken } from "../../utils/storage";
import ServicesAPI from "../../services/services";
import { handleShowContextualLoader } from "../../utils/contextualLoaderTrigger";
import Cookies from "js-cookie";
import { clearRegisterData } from "../../redux/slices/registerSlice";
import { redirectToOnboardingJourney } from "../../utils/utils";
import { googleEvent_ONB029 } from "../../lib/google-analytics";
import { profilePushIdentity } from "../../lib/clevertap-events";

export default function AutoLogin() {
  const [searchParams] = useSearchParams();

  const { autoLoginAPI } = new ServicesAPI();

  const token = searchParams.get("token");

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (token) {
      handleAutoLogin();
    }
  }, [token]);

  const handleAutoLogin = async () => {
    const allCookies = Cookies.get();
    Object.keys(allCookies).forEach((cookieName) => {
      Cookies.remove(cookieName, { path: "/" });
    });

    localStorage.clear();
    dispatch(clearUserData());
    dispatch(clearRegisterData());

    await new Promise((res) => setTimeout(res, 2000));

    try {
      const res = await autoLoginAPI(token);
      const jwtToken = res.data.jwtToken;
      if(res?.data?.redirectionToNew) {
        return redirectToOnboardingJourney(jwtToken);
      }
      const accessToken = res.data.accessToken;
      const {customerID, mobile: phoneNo, pancard, name, dob, gender, email} = res?.data?.customer || {};

      storeToken(jwtToken);
      storeAccessToken(accessToken);
      storeCustomerID(customerID);
      storePhoneNo(phoneNo);
      localStorage.setItem("customerType", res?.data?.lead?.customer_type);
      localStorage.setItem("pancard", pancard);
      localStorage.setItem("email", email);
      storeProductId(res?.data?.lead?.productId);
      storeLeadID(res?.data?.lead?.leadID);
      storeAttributeKey(res?.data?.attributeKey);

      dispatch(addUserName(name));
      dispatch(addUserInfo(res?.data?.customer));

      // Cookies
      Cookies.set("customerID", customerID, { expires: 7 });

      profilePushIdentity({ customerID, mobile: phoneNo, dob, gender, name, email });

      // Credeau SDK
      fetchCredeauData(res?.data?.customer?.customerID);
      localStorage.setItem("custId", res?.data?.customer?.customerID);

      setTimeout(() => {
        googleEvent_ONB029();
        if (res?.data?.journey) {
        
          if (window.parent) {
            window.parent.location.href =  `${res.data.journey}`;
          } else {
            window.location.href = `${res.data.journey}`;
          }
        } else {
          navigate("/home");
        }
      }, 100);
    } catch (error) {
      console.log("Error:", error);
    }
  };

  return <div>{handleShowContextualLoader("Please wait...")}</div>;
}
